/*
 * Pete in the header search (PondLinersco).
 * - The dropdown (assets/plx-search.js) gets an "Ask Pete" row on top of every set of results, and an
 *   invitation to ask Pete when the field is empty.
 * - Questions typed into the search ("what size liner for 3m x 2m?") open Pete instead of a results page;
 *   product and size searches ("EPDM", "4x3") still go to the normal search.
 * - The search bar's mic opens Pete and starts listening, so customers talk to Pete and hear him answer.
 * - The search results page gets a Pete box above the results (and a bigger one when nothing is found).
 * Loaded by snippets/pete.liquid after pete.js. Everything waits for window.PeteChat.
 */
(function () {
  'use strict';
  var QUESTION = /^(how|what|whats|what's|which|why|when|where|who|can|could|do|does|did|is|are|should|will|would|i|im|i'm|my|we|our|help|need|recommend|best|tell|explain|advice)\b/i;
  var SIZE = /\d+(\.\d+)?\s*(m|ft|')?\s*(x|by)\s*\d/i;

  function isQuestion(q) {
    q = (q || '').trim();
    if (!q) return false;
    if (q.indexOf('?') !== -1) return true;
    if (QUESTION.test(q)) return true;
    var words = q.split(/\s+/).length;
    return words >= 6 && !(SIZE.test(q) && words <= 7);
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function pete() { return window.PeteChat; }
  function ask(q, source) {
    var p = pete();
    if (!p) return false;
    closeDropdown();
    p.open(q, source);
    return true;
  }

  var input = document.querySelector('[data-plxs-input]');
  var form = input && input.form;
  var results = document.querySelector('[data-plxs-results]');
  var deflt = document.querySelector('[data-plxs-default]');

  function closeDropdown() {
    if (!input) return;
    input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    input.blur();
  }

  var SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2l1.9 5.6L19.5 9.5l-5.6 1.9L12 17l-1.9-5.6L4.5 9.5l5.6-1.9zM19 14l.9 2.6 2.6.9-2.6.9L19 21l-.9-2.6-2.6-.9 2.6-.9z"/></svg>';

  // ---------- "Ask Pete" row in the dropdown ----------
  function peteRow(q) {
    return '<button type="button" class="pete-sr" data-pete-sr="' + esc(q) + '">' +
      '<span class="pete-sr__av" aria-hidden="true">P</span>' +
      '<span class="pete-sr__txt"><b>Ask Pete: “' + esc(q) + '”</b>' +
      '<small>Our AI pond specialist answers in seconds, with the right size and price</small></span>' +
      '<span class="pete-sr__go" aria-hidden="true">' + SPARK + '</span></button>';
  }
  function decorateResults() {
    if (!results || results.hidden || !input) return;
    var q = input.value.trim();
    if (!q) return;
    var row = results.querySelector('.pete-sr');
    if (row && row.getAttribute('data-pete-sr') === q) return;
    if (row) row.remove();
    var noneBox = results.querySelector('.plxs__none');
    results.insertAdjacentHTML('afterbegin', peteRow(q));
    if (noneBox) results.querySelector('.pete-sr').classList.add('pete-sr--big');
  }
  function decorateDefault() {
    if (!deflt || deflt.querySelector('.pete-sr')) return;
    deflt.insertAdjacentHTML('afterbegin',
      '<button type="button" class="pete-sr pete-sr--invite" data-pete-sr="">' +
      '<span class="pete-sr__av" aria-hidden="true">P</span>' +
      '<span class="pete-sr__txt"><b>Not sure what you need? Ask Pete</b>' +
      '<small>Tell him your pond size and what it’s for: he’ll pick the liner, size and kit</small></span>' +
      '<span class="pete-sr__go" aria-hidden="true">' + SPARK + '</span></button>');
  }
  if (results) {
    new MutationObserver(function () { decorateResults(); }).observe(results, { childList: true, attributes: true, attributeFilter: ['hidden'] });
  }
  decorateDefault();

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pete-sr]');
    if (!b) return;
    e.preventDefault();
    var q = b.getAttribute('data-pete-sr');
    if (!ask(q || null, 'search_row')) return;
  });

  // ---------- questions typed into the search open Pete ----------
  if (form) {
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!isQuestion(q) || !pete()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'sn_specialist', sn_action: 'search_question', sn_source: 'pete' }); } catch (err) {}
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      ask(q, 'search_question');
    }, true);
  }

  // ---------- the search mic talks to Pete ----------
  document.addEventListener('click', function (e) {
    var mic = e.target.closest && e.target.closest('[data-plxsb-mic]');
    if (!mic || !pete() || !pete().talk) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    closeDropdown();
    pete().talk('search_mic');
  }, true);
  var micBtn = document.querySelector('[data-plxsb-mic]');
  if (micBtn) {
    micBtn.hidden = false; // Pete's voice works in every browser, not only those with built-in dictation
    micBtn.setAttribute('aria-label', 'Talk to Pete, our pond specialist');
    micBtn.setAttribute('title', 'Talk to Pete');
  }

  // ---------- search results page ----------
  function searchPage() {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    var q = new URLSearchParams(location.search).get('q');
    if (!q || document.querySelector('.pete-sp')) return;
    var host = document.querySelector('#MainContent .template-search__header') ||
      document.querySelector('#MainContent .template-search') || document.querySelector('#MainContent');
    if (!host) return;
    var none = !document.querySelector('#MainContent .product-grid li, #MainContent .card-wrapper');
    var box = document.createElement('section');
    box.className = 'pete-sp' + (none ? ' pete-sp--none' : '');
    var lead = none ? 'No exact match for “' + esc(q) + '”, but Pete can help'
      : 'Not sure which of these is right for your pond?';
    var chips = none ? ['Find me the right product for: ' + q, 'What do I need for my pond?']
      : ['Which of these is best for my pond?', 'What size ' + q + ' do I need?', 'Is ' + q + ' safe for fish?'];
    box.innerHTML = '<span class="pete-sp__av" aria-hidden="true">P</span><div class="pete-sp__body">' +
      '<b class="pete-sp__lead">' + lead + '</b>' +
      '<p>Ask Pete, our AI pond specialist. Tell him your pond size and he’ll pick the right one, with the size and price.</p>' +
      '<div class="pete-sp__chips">' + chips.map(function (c) {
        var full = /^(Which|What|Is|Find)/.test(c) && c.indexOf(q) === -1 ? c + ' (I searched for “' + q + '”)' : c;
        return '<button type="button" class="pete-sp__chip" data-pete-sr="' + esc(full) + '">' + esc(c) + '</button>';
      }).join('') + '<button type="button" class="pete-sp__talk" data-pete-talk>' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/></svg>Talk to Pete</button></div></div>';
    if (host.id === 'MainContent') host.insertBefore(box, host.firstChild); else host.parentNode.insertBefore(box, host.nextSibling);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pete-talk]');
    if (!t || !pete()) return;
    e.preventDefault();
    pete().talk('search_page');
  });

  function ready() { searchPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
